// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"4701":"svg-icons","8177":"remix-icons","9222":"blueprint-icons"}[chunkId] || chunkId) + "." + {"2570":"9d010338","3073":"44ba2e46","4701":"ad55a8cc","5143":"18ee6eac","6128":"c3cb0787","8177":"3231877c","8582":"a6c1613b","9222":"caf2375a"}[chunkId] + ".chunk.js";
};